export const skillsData = [
  "HTML",
  "CSS",
  "Javascript",
  "React",
  "Next JS",
  "Node JS",
  "PostgreSQL",
  "Ruby",
  "Nginx",
  "Firebase",
  "Tailwind",
  "AWS",
];
